import { c as _c } from "react/compiler-runtime";
import { BackupPolicyType, ResourceType } from '@repo/api-gw-sdk';
import { useMemo } from 'react';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { useSupportedResourceTypes } from '@/data/inventory/useSupportedResourceTypes';
export const useBackupPolicyAvailableTypes = () => {
  const $ = _c(50);
  const {
    GcpVmHighFrequencyBackupEnabled,
    RdsHighFrequencyBackupEnabled,
    SapHanaPitrSupport,
    AzureSqlVirtualMachineSupport,
    EnableBigQueryNativePolicy,
    AwsKeyspacesSupport,
    MongoAtlasSupport,
    AzureFilesSupport,
    AwsRdsNativeBackupSupport,
    GoogleWorkspaceSupport,
    Microsoft365Support
  } = useFeatureFlags();
  const allTypes = useSupportedResourceTypes();
  let t0;
  if ($[0] !== GcpVmHighFrequencyBackupEnabled) {
    t0 = GcpVmHighFrequencyBackupEnabled ? [ResourceType.GcpComputeEngineInstance] : [];
    $[0] = GcpVmHighFrequencyBackupEnabled;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== RdsHighFrequencyBackupEnabled) {
    t1 = RdsHighFrequencyBackupEnabled ? [ResourceType.AwsRds] : [];
    $[2] = RdsHighFrequencyBackupEnabled;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== AwsKeyspacesSupport) {
    t2 = AwsKeyspacesSupport ? [ResourceType.AwsKeyspacesTable] : [];
    $[4] = AwsKeyspacesSupport;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== MongoAtlasSupport) {
    t3 = MongoAtlasSupport ? [ResourceType.AtlasMongodbCluster] : [];
    $[6] = MongoAtlasSupport;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = [ResourceType.AwsEc2, ...t0, ...t1, ResourceType.AwsDynamoDb, ...t2, ResourceType.AwsS3, ResourceType.GcpCloudStorageBucket, ...t3];
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const HighFrequencySupportedResourceTypes = t4;
  let t5;
  if ($[13] !== AzureSqlVirtualMachineSupport) {
    t5 = AzureSqlVirtualMachineSupport ? [ResourceType.AzureSqlVirtualMachine] : [];
    $[13] = AzureSqlVirtualMachineSupport;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== SapHanaPitrSupport) {
    t6 = SapHanaPitrSupport ? [ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm] : [];
    $[15] = SapHanaPitrSupport;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = [...t5, ...t6];
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const pitrPolicySupportedResourceTypes = t7;
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [ResourceType.AwsRds];
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const nativePitrPolicySupportedResourceTypes = t8;
  let t9;
  if ($[21] !== EnableBigQueryNativePolicy) {
    t9 = [...(EnableBigQueryNativePolicy ? [ResourceType.GcpBigQuery] : [])];
    $[21] = EnableBigQueryNativePolicy;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const bigQueryNativePitrSupportedResourceTypes = t9;
  let t10;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [ResourceType.AzureSqlDatabase];
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  const azureSqlDatabaseNativePitrSupportedResourceTypes = t10;
  let t11;
  if ($[24] !== AwsRdsNativeBackupSupport) {
    t11 = [ResourceType.AwsFsx, ResourceType.AwsEfs, ResourceType.AwsDocumentdb, ResourceType.AwsNeptune, ...(AwsRdsNativeBackupSupport ? [ResourceType.AwsRds] : [])];
    $[24] = AwsRdsNativeBackupSupport;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const awsNativeStandardPolicySupportedResourceTypes = t11;
  let t12;
  if ($[26] !== AzureFilesSupport) {
    t12 = [...(AzureFilesSupport ? [ResourceType.AzureFileShare] : [])];
    $[26] = AzureFilesSupport;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const azureFilesPolicySupportedResourceTypes = t12;
  let t13;
  if ($[28] !== GoogleWorkspaceSupport) {
    t13 = [...(GoogleWorkspaceSupport ? [ResourceType.GoogleWorkspaceResource] : [])];
    $[28] = GoogleWorkspaceSupport;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  const googleWorkspacePolicySupportedResourceTypes = t13;
  let t14;
  if ($[30] !== Microsoft365Support) {
    t14 = [...(Microsoft365Support ? [ResourceType.Microsoft365Resource] : [])];
    $[30] = Microsoft365Support;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const microsoft365PolicySupportedResourceTypes = t14;
  let t15;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = [ResourceType.AwsRds];
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  const dualSupportedResourceTypes = t15;
  let t16;
  if ($[33] !== allTypes || $[34] !== awsNativeStandardPolicySupportedResourceTypes || $[35] !== azureFilesPolicySupportedResourceTypes) {
    let t17;
    if ($[37] !== awsNativeStandardPolicySupportedResourceTypes || $[38] !== azureFilesPolicySupportedResourceTypes) {
      t17 = type => (!awsNativeStandardPolicySupportedResourceTypes.includes(type) || dualSupportedResourceTypes.includes(type)) && !azureFilesPolicySupportedResourceTypes.includes(type) && type !== ResourceType.GoogleWorkspaceResource && type !== ResourceType.Microsoft365Resource;
      $[37] = awsNativeStandardPolicySupportedResourceTypes;
      $[38] = azureFilesPolicySupportedResourceTypes;
      $[39] = t17;
    } else {
      t17 = $[39];
    }
    t16 = [...allTypes.filter(t17)];
    $[33] = allTypes;
    $[34] = awsNativeStandardPolicySupportedResourceTypes;
    $[35] = azureFilesPolicySupportedResourceTypes;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const standardPolicySupportedResourceTypes = t16;
  let t17;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = [];
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== HighFrequencySupportedResourceTypes || $[42] !== awsNativeStandardPolicySupportedResourceTypes || $[43] !== azureFilesPolicySupportedResourceTypes || $[44] !== bigQueryNativePitrSupportedResourceTypes || $[45] !== googleWorkspacePolicySupportedResourceTypes || $[46] !== microsoft365PolicySupportedResourceTypes || $[47] !== pitrPolicySupportedResourceTypes || $[48] !== standardPolicySupportedResourceTypes) {
    t18 = {
      [BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY]: HighFrequencySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_PITR]: pitrPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_PITR]: nativePitrPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_STANDARD]: standardPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_STANDARD]: awsNativeStandardPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR]: bigQueryNativePitrSupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_SQL_DATABASE_NATIVE_PITR]: azureSqlDatabaseNativePitrSupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_FILES]: azureFilesPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_GOOGLE_WORKSPACE]: googleWorkspacePolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_MICROSOFT_365]: microsoft365PolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_UNSPECIFIED]: t17
    };
    $[41] = HighFrequencySupportedResourceTypes;
    $[42] = awsNativeStandardPolicySupportedResourceTypes;
    $[43] = azureFilesPolicySupportedResourceTypes;
    $[44] = bigQueryNativePitrSupportedResourceTypes;
    $[45] = googleWorkspacePolicySupportedResourceTypes;
    $[46] = microsoft365PolicySupportedResourceTypes;
    $[47] = pitrPolicySupportedResourceTypes;
    $[48] = standardPolicySupportedResourceTypes;
    $[49] = t18;
  } else {
    t18 = $[49];
  }
  const policySupportedResourceTypes = t18;
  return policySupportedResourceTypes;
};